<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="video-feedback"
      :class="{ 'is-full-screen': isFullScreen }"
    >
      <div class="video-feedback-close" @click="handleClose">
        <!-- 倒计时loading动画 -->
        <svg v-show="isShowCloseLoading" class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" />
          <circle class="border" :style="circlePathStyle" cx="50" cy="50" r="20" fill="none" />
        </svg>
        <!-- End 倒计时loading动画 -->

        <icon type="iconic_cancel_pop"></icon>
      </div>
      
      <div class="video-feedback-control">
        <span
          class="video-feedback-control-button"
          :class="usefulBtnClass"
          @click="handlerClickUsefulBtn"
        >
          <icon type="iconic_useful"></icon>
          <span>有帮助</span>
        </span>

        <span
          class="video-feedback-control-button"
          :class="uselessBtnClass"
          @click="handlerClickUselessBtn"
        >
          <icon type="iconic_useless"></icon>
          <span>无帮助</span>
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
import FEEDBACK_STATUS from '@/common/constant/feedback-help';

export default {
  props: {
    id: [Number, String],
    series: [Number, String],

    show: {
      type: Boolean,
      default: false,
    },
    
    player: {
      type: Object,
      default: null
    },

    reportShow: Function,
    reportClick: Function,
    isFullScreen: Boolean,
  },

  data() {
    return {
      visible: false,
      isShowCloseLoading: false,
      percentage: 0,

      isHelp: FEEDBACK_STATUS.deafult,
      useful: null,
    };
  },

  computed: {
    circlePathStyle() {
      let perimeter = 2 * Math.PI * 20;
      return {
        strokeDasharray: `${perimeter}px, ${perimeter}px`,
        strokeDashoffset: `${perimeter * (this.percentage / 100)}px`,
        transition: 'strokeDashoffset 0.35s ease 0s, stroke 0.35s ease'
      };
    },

    usefulBtnClass() {
      switch (this.isHelp) {
        case FEEDBACK_STATUS.help:
          return 'is-selected';
        case FEEDBACK_STATUS.unhelp:
          return 'is-unselected';
        default:
          return '';
      }
    },

    uselessBtnClass() {
      switch (this.isHelp) {
        case FEEDBACK_STATUS.unhelp:
          return 'is-selected';
        case FEEDBACK_STATUS.help:
          return 'is-unselected';
        default:
          return '';
      }
    },
  },

  watch: {
    show(val) {
      if (val) {
        this.open();
      } else {
        this.close();
      }
    },
  },

  methods: {
    handleVideoPlay() {
      this.isShowCloseLoading = true;
    },

    handleVideoPause() {
      this.isShowCloseLoading = false;
    },

    handleVideoTimeUpdate() {
      const maxTime = this.player.duration();
      const currentTime = this.player.currentTime();
      let diffTime = maxTime - currentTime;
      if (diffTime > 5 && diffTime <= 15) {
        let tempPercentage = (15 - diffTime) / 10 * 100;
        tempPercentage = tempPercentage > 100 ? 100 : tempPercentage;
        tempPercentage = tempPercentage < 0 ? 0 : tempPercentage;
        this.percentage = tempPercentage;
      } else {
        this.isShowCloseLoading = false;
      }
    },

    open() {
      this.visible = true;
      this.$emit('update:show', this.visible);
      this.reportShow({ 
        show: 'initial', 
        area: this.isFullScreen ? 'video_full' : 'video_window',
        type: this.id,
        series: this.series
      });

      // 注册视频相关事件处理loading
      if (this.player) {
        this.isShowCloseLoading = true;
        this.player.on('play', this.handleVideoPlay);
        this.player.on('pause', this.handleVideoPause);
        this.player.on('timeupdate', this.handleVideoTimeUpdate);
      }
    },

    close() {
      this.isShowCloseLoading = false;
      this.percentage = 0;
      this.visible = false;
      this.$emit('update:show', this.visible);
      // 解绑视频相关事件处理loading
      if (this.player) {
        this.player.off('play', this.handleVideoPlay);
        this.player.off('pause', this.handleVideoPause);
        this.player.off('timeupdate', this.handleVideoTimeUpdate);
      }
    },

    handleClose() {
      this.close();
      this.reportClick({ 
        click: 'close',
        area: 'video_playing'
      });
    },

    async handlerClickUsefulBtn() {
      this.isHelp = FEEDBACK_STATUS.help;
      this.reportClick({ 
        click: 'help',
        area: 'video_playing',
        type: this.id,
        series: this.series
      });
      await this.handleSubmit(1);
    },

    async handlerClickUselessBtn() {
      this.isHelp = FEEDBACK_STATUS.unhelp;
      this.reportClick({ 
        click: 'nohelp',
        area: 'video_playing',
        type: this.id,
        series: this.series
      });
      await this.handleSubmit(0);
    },

    async handleSubmit(val) {
      this.$emit('useful-click', val);
      // 已选择不能调整
      if (this.useful !== null || this.usefulLoading) return;
      this.usefulLoading = true;

      const token = await this.$service.learning.getFbToken().catch(() => '');

      const res = await this.$service.learning.submitComment({
        token,
        id: this.id,
        isHelp: val,
        fromChannel: 5,
      });

      if (res.code === 200) {
        this.useful = val;
      } else {
        this.$toast('提交失败，请重试');
      }

      this.close();
      this.usefulLoading = false;
    },
  },

  beforeDestroy() {
    // 解绑视频相关事件处理loading
    if (this.player) {
      this.player.off('play', this.handleVideoPlay);
      this.player.off('pause', this.handleVideoPause);
      this.player.off('timeupdate', this.handleVideoTimeUpdate);
    }
  }
};
</script>

<style lang="scss" scoped>
.video-feedback {
  position: absolute;
  top: calc((100% - 56px) * 4/5 );
  right: 24px;
  width: 200px;
  padding: 20px 16px 12px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;

  font-family: '微软雅黑';

  &.is-full-screen {
    top: calc((100% - 72px) * 4/5 );
    width: 288px;

    .video-feedback-content {
      font-size: 14px;
    }

    .video-feedback-control {

      &-button {
        width: 120px;
        height: 40px;
        border-radius: 20px;

        font-size: 14px;

        & + .video-feedback-control-button {
          margin-left: 16px;
        }
      }
    }
  }

  &-close {
    position: absolute;
    top: 4px;
    right: 4px;

    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;

    font-size: 8px;
    color: #a0a09f;
    cursor: pointer;

    &:hover {
      color: #d0d0d0;
    }

    &:active {
      color: #999999;
    }

    .circular {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 16px;
      height: 16px;
      transform: translate(-50%, -50%) rotate(-90deg);
      transform-origin: center center;

      .path {
        stroke-width: 3;
        stroke: rgba($color: #000000, $alpha: .4);
        stroke-linecap: round;
      }
    
      .border {
        stroke-width: 3;
        stroke: rgba($color: #498FF2, $alpha: .85);
        stroke-linecap: round;
      }
    }
  }

  &-content {
    height: 22px;
    line-height: 22px;

    font-size: 12px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.95);
  }

  &-control {
    display: flex;
    align-items: center;
    justify-content: center;

    &-button {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 80px;
      height: 24px;
      background-color: rgba(255, 255, 255, 0.3);
      border-radius: 12px;

      font-size: 12px;
      color: #ffffff;
      user-select: none;
      cursor: pointer;

      &:hover {
        background-color: rgba(255, 255, 255, 0.4);
      }

      &:active {
        background-color: rgba(255, 255, 255, 0.25);
      }

      &.is-selected {
        background-color: #417ff9;
      }

      .icon {
        font-size: 16px;
        margin-right: 4px;
      }

      & + .video-feedback-control-button {
        margin-left: 8px;
      }
    }
  }
}

.fade {
  &-enter-active {
    transition: all 1s;
  }

  &-leave-active {
    transition: all 1s;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
}
</style>
